import { isNil, map } from "lodash";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-searchbox";
const langTools = ace.acequire("ace/ext/language_tools");
const snippetsModule = ace.acequire("ace/snippets");

// By default Ace will try to load snippet files for the different modes and fail.
// We don't need them, so we use these placeholders until we define our own.
function defineDummySnippets(mode) {
  ace.define(
    `ace/snippets/${mode}`,
    ["require", "exports", "module"],
    (require, exports) => {
      exports.snippetText = "";
      exports.scope = mode;
    }
  );
}

defineDummySnippets("sql");

function buildTableColumnKeywords(tableName, columns, caseSensitive) {
  const keywords = [];
  Object.keys(columns).forEach((columnName) => {
    const value =caseSensitive ? `${tableName}.${columnName}`:`${tableName.toLowerCase()}.${columnName.toLowerCase()}`;
    keywords.push({
      name: value,
      value: value,
      score: 100,
      meta: "Column",
    });
  });
  return keywords;
}

function buildKeywordsFromSchema(tables, caseSensitive) {
  const tableKeywords = [];
  const columnKeywords = {};
  const tableColumnKeywords = {};

  Object.keys(tables).forEach((tableName) => {
    tableKeywords.push({
      name: caseSensitive? tableName: tableName.toLowerCase(),
      value: caseSensitive? tableName: tableName.toLowerCase(),
      score: 100,
      meta: "",
    });
    const columns = tables[tableName].columns;
    tableColumnKeywords[tableName.toLowerCase()] = buildTableColumnKeywords(
      tableName,
      columns,
      caseSensitive
    );
    Object.keys(columns).forEach((columnName) => {
      const value = caseSensitive ? `${tableName}.${columnName}`:`${tableName.toLowerCase()}.${columnName.toLowerCase()}`;
      columnKeywords[
        `${tableName.toLowerCase()} ${columnName.toLowerCase()}`
      ] = {
        type: "",
        value: value,
      };
    });
  });

  return {
    table: tableKeywords,
    column: map(columnKeywords, (v, k) => ({
      caption: k,
      value: v.value,
      score: 50,
      meta: v.type,
    })),
    tableColumn: tableColumnKeywords,
  };
}

const schemaCompleterKeywords = {};

function updateSchemaCompleter(editorKey, schema = null, caseSensitive) {
  schemaCompleterKeywords[editorKey] = isNil(schema)
    ? null
    : buildKeywordsFromSchema(schema, caseSensitive);
}

langTools.setCompleters([
  langTools.snippetCompleter,
  langTools.keyWordCompleter,
  langTools.textCompleter,
  {
    identifierRegexps: [/[a-zA-Z_0-9.\-\u00A2-\uFFFF]/],
    getCompletions: (editor, session, pos, prefix, callback) => {
      const { table, column, tableColumn } = schemaCompleterKeywords[
        editor.id
      ] || {
        table: [],
        column: [],
        tableColumn: [],
      };

      if (prefix.length === 0 || table.length === 0) {
        callback(null, []);
        return;
      }

      if (prefix[prefix.length - 1] === ".") {
        const tableName = prefix.substring(0, prefix.length - 1);
        callback(null, table.concat(tableColumn[tableName.toLowerCase()]));
        return;
      }
      callback(null, table.concat(column));
    },
  },
]);

export { AceEditor, langTools, snippetsModule, updateSchemaCompleter };



// WEBPACK FOOTER //
// ./src/components/Query/ace_messages.js